export const history = require("history").createBrowserHistory({
    forceRefresh: true
})


// WEBPACK FOOTER //
// ./src/helper/history.js